import axios from "axios";
import { useQuery } from "react-query";
import { sortBy } from "lodash";

export function useBarrierHeights() {
  async function queryFn() {
    const response = await axios.get<number[]>("/planning-api/barrierheights");

    return sortBy(response.data, "serialNumber");
  }

  return useQuery<number[], Error>(["barrierheights"], queryFn, {
    staleTime: Number.POSITIVE_INFINITY,
    refetchOnWindowFocus: false,
  });
}
